import {create} from 'zustand';

import {WeatherLocation} from '@/models/dto/system/weather-location';

interface WeatherLocationStore {
  locations: WeatherLocation[];
  setWeatherLocations: (locations: WeatherLocation[]) => void;
  findByEmd: (sgg: string, emd: string) => WeatherLocation | undefined;
  findByLatLng: (lat: number, lon: number) => WeatherLocation | undefined;
}

export const useWeatherLocationStore = create<WeatherLocationStore>((set, get) => ({
  locations: [],

  setWeatherLocations: (locations) => set({locations}),

  findByEmd: (sgg, emd) => {
    return get().locations.find((loc) => loc.sgg === sgg && loc.emd === emd);
  },

  findByLatLng: (lat, lon) => {
    const toRad = (deg: number) => (deg * Math.PI) / 180;
    const distance = (a: WeatherLocation) => {
      return Math.sqrt(Math.pow(a.lat - lat, 2) + Math.pow(a.lon - lon, 2));
    };

    return get().locations.reduce(
      (closest, loc) => {
        if (!closest) return loc;
        return distance(loc) < distance(closest) ? loc : closest;
      },
      undefined as WeatherLocation | undefined
    );
  }
}));
